import { FilterDto, FilterType } from '../../../types/FilterDto';
import type { TFunction } from "i18next";
import { LineStateEnum } from '../types/enums';


export const getFiltersSurveyImportDetails = async (t: TFunction<[string], undefined>): Promise<FilterDto[]> => {

    const staticFilters: FilterDto[] = [
        {
            name: 'StatusRow',
            description: t("survey:load.filterStatus"),
            type: FilterType.MULTIPLE,
            values: (Object.keys(LineStateEnum) as (keyof typeof LineStateEnum)[])
                .filter((key) => LineStateEnum[key] !== LineStateEnum.Cancel)
                .map((key) => ({
                    key: LineStateEnum[key],
                    value: t(`survey:statusType.${key}`)
                }))
                .sort((a, b) => a.value.localeCompare(b.value))
        },
        {
            name: 'AnswerDate',
            description: t("survey:load.filterAnswerDate"),
            type: FilterType.DATE,
            values: []
        },
    ];

    return [...staticFilters ];
};
